if(typeof _GIRL_CONF['geeky']['game_memory']=='undefined'){_GIRL_CONF['geeky']['game_memory']={};};
_GIRL_CONF['geeky']['game_memory']['face']={left:548,top:201,width:206,height:156};
_GIRL_CONF['geeky']['game_memory']['hair']={left:438,top:54,width:403,height:301};
_GIRL_CONF['geeky']['game_memory']['hand1']={left:492,top:280,width:317,height:446};
_GIRL_CONF['geeky']['game_memory']['hand2']={left:671,top:249,width:132,height:327};
_GIRL_CONF['geeky']['game_memory']['item1']={left:186,top:247,width:228,height:438};
_GIRL_CONF['geeky']['game_memory']['item2']={left:868,top:370,width:146,height:293};
_GIRL_CONF['geeky']['game_memory']['tits']={left:563,top:354,width:93,height:147};
